import { QueryClient } from "@tanstack/react-query";

/**
 * Configured QueryClient with sensible app-wide defaults.
 *
 * - staleTime 30s: queries are considered fresh for half a minute, so
 *   tab switches don't refetch on every focus.
 * - retry 2: temporary Supabase blips don't surface as errors.
 * - refetchOnWindowFocus false: avoid surprise loading flickers.
 * - mutations don't retry by default (avoid duplicate writes).
 *
 * Override per-query in callsites where these defaults don't fit.
 */
export function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: 2,
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: 0,
      },
    },
  });
}
